import { useAppContext } from '@at/sauron-platform-core'
import { useLocation } from 'react-router-dom'
import { getChannelFromPathnameOrAdvertisingLocation } from '../utils/channel-utilities'
import { AbTestNames } from '../utils/ab-test/ab-test.utils'

export const useChannel = () => {
    const { pathname, search } = useLocation()
    return getChannelFromPathnameOrAdvertisingLocation(pathname, search)
}

export const useMobileCarouselWithFourImages = () => {
    const { matchesTestGroups } = useAppContext()
    return matchesTestGroups(
        AbTestNames.MOBILE_CAROUSEL_WITH_FOUR_IMAGESW,
        AbTestNames.MOBILE_CAROUSEL_WITH_FOUR_IMAGESX,
        AbTestNames.MOBILE_CAROUSEL_WITH_FOUR_IMAGESY,
        AbTestNames.MOBILE_CAROUSEL_WITH_FOUR_IMAGESZ
    )
}

export const useNewLeasingCard = () => {
    const { matchesTestGroups } = useAppContext()
    return matchesTestGroups(AbTestNames.NEW_LEASING_CARD)
}

export const useCategoryTags = () => {
    const { matchesTestGroups } = useAppContext()
    return matchesTestGroups(AbTestNames.CATEGORY_TAGS_IM_LOOKING_FOR)
}

export const useFlexibleFinanceFilters = () => {
    const { matchesTestGroups } = useAppContext()
    return matchesTestGroups(AbTestNames.FLEXIBLE_FINANCE_FILTERS)
}
